export const IconVia = ({ via }: any) => {
  if (via === "Bot helppeople") {
    return (
      <svg
        width="16"
        height="11"
        viewBox="0 0 16 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M13.75 12C14.0455 12 14.3381 12.0582 14.611 12.1713C14.884 12.2843 15.1321 12.4501 15.341 12.659C15.5499 12.8679 15.7157 13.116 15.8287 13.389C15.9418 13.6619 16 13.9545 16 14.25V15.155C16.0001 15.6956 15.8834 16.2297 15.6578 16.721C15.4322 17.2122 15.1031 17.6488 14.693 18.001C13.127 19.345 10.887 20 7.997 20C5.107 20 2.869 19.344 1.306 18C0.896462 17.6481 0.567754 17.2119 0.342351 16.7212C0.116949 16.2305 0.000170037 15.697 0 15.157V14.249C0.000265139 13.6524 0.237435 13.0804 0.659363 12.6587C1.08129 12.2369 1.65344 12 2.25 12H13.75ZM13.75 13.5H2.25C2.05109 13.5 1.86032 13.579 1.71967 13.7197C1.57902 13.8603 1.5 14.0511 1.5 14.25V15.158C1.5 15.813 1.786 16.436 2.284 16.864C3.542 17.945 5.437 18.502 7.997 18.502C10.557 18.502 12.455 17.945 13.716 16.862C13.9618 16.6509 14.1591 16.3891 14.2944 16.0947C14.4298 15.8002 14.4999 15.48 14.5 15.156V14.25C14.5 14.0511 14.421 13.8603 14.2803 13.7197C14.1397 13.579 13.9489 13.5 13.75 13.5ZM7.895 0.0079999L7.997 0C8.17824 7.6429e-06 8.35334 0.0656426 8.48993 0.184767C8.62652 0.303891 8.71535 0.468446 8.74 0.648L8.747 0.75V1.5H12.247C12.8437 1.5 13.416 1.73705 13.838 2.15901C14.2599 2.58097 14.497 3.15326 14.497 3.75V8.255C14.497 8.85174 14.2599 9.42403 13.838 9.84599C13.416 10.2679 12.8437 10.505 12.247 10.505H3.747C3.15026 10.505 2.57797 10.2679 2.15601 9.84599C1.73405 9.42403 1.497 8.85174 1.497 8.255V3.75C1.497 3.15326 1.73405 2.58097 2.15601 2.15901C2.57797 1.73705 3.15026 1.5 3.747 1.5H7.247V0.751C7.24701 0.569762 7.31264 0.394658 7.43177 0.25807C7.55089 0.121481 7.71545 0.0326482 7.895 0.0079999L7.997 0L7.895 0.00699997V0.0079999ZM12.247 3H3.747C3.54809 3 3.35732 3.07902 3.21667 3.21967C3.07602 3.36032 2.997 3.55109 2.997 3.75V8.255C2.997 8.669 3.333 9.005 3.747 9.005H12.247C12.4459 9.005 12.6367 8.92598 12.7773 8.78533C12.918 8.64468 12.997 8.45391 12.997 8.255V3.75C12.997 3.55109 12.918 3.36032 12.7773 3.21967C12.6367 3.07902 12.4459 3 12.247 3ZM5.747 4.5C6.07852 4.5 6.39646 4.6317 6.63088 4.86612C6.8653 5.10054 6.997 5.41848 6.997 5.75C6.997 6.08152 6.8653 6.39946 6.63088 6.63388C6.39646 6.8683 6.07852 7 5.747 7C5.41548 7 5.09754 6.8683 4.86312 6.63388C4.6287 6.39946 4.497 6.08152 4.497 5.75C4.497 5.41848 4.6287 5.10054 4.86312 4.86612C5.09754 4.6317 5.41548 4.5 5.747 4.5ZM10.239 4.5C10.4061 4.49527 10.5724 4.5241 10.7281 4.58476C10.8838 4.64543 11.0258 4.73671 11.1456 4.8532C11.2655 4.9697 11.3607 5.10904 11.4258 5.26299C11.4908 5.41694 11.5244 5.58237 11.5244 5.7495C11.5244 5.91663 11.4908 6.08206 11.4258 6.23601C11.3607 6.38996 11.2655 6.5293 11.1456 6.64579C11.0258 6.76229 10.8838 6.85357 10.7281 6.91424C10.5724 6.9749 10.4061 7.00373 10.239 6.999C9.91373 6.9898 9.60487 6.85412 9.37806 6.6208C9.15124 6.38747 9.02435 6.0749 9.02435 5.7495C9.02435 5.4241 9.15124 5.11153 9.37806 4.8782C9.60487 4.64488 9.91373 4.5092 10.239 4.5Z"
          fill="#3948FF"
        />
      </svg>
    );
  } else if (via === "Chat web") {
    return (
      <span>
        <svg
          className="h-4"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 473 473"
        >
          <path
            stroke="#3c6ebe"
            d="M403.581 69.3c-44.7-44.7-104-69.3-167.2-69.3s-122.5 24.6-167.2 69.3c-86.4 86.4-92.4 224.7-14.9 318-7.6 15.3-19.8 33.1-37.9 42-8.7 4.3-13.6 13.6-12.1 23.2s8.9 17.1 18.5 18.6c4.5.7 10.9 1.4 18.7 1.4 20.9 0 51.7-4.9 83.2-27.6 35.1 18.9 73.5 28.1 111.6 28.1 61.2 0 121.8-23.7 167.4-69.3 44.7-44.7 69.3-104 69.3-167.2s-24.7-122.5-69.4-167.2zm-19.1 315.3c-67.5 67.5-172 80.9-254.2 32.6-5.4-3.2-12.1-2.2-16.4 2.1-.4.2-.8.5-1.1.8-27.1 21-53.7 25.4-71.3 25.4h-.1c20.3-14.8 33.1-36.8 40.6-53.9 1.2-2.9 1.4-5.9.7-8.7-.3-2.7-1.4-5.4-3.3-7.6-73.2-82.7-69.4-208.7 8.8-286.9 81.7-81.7 214.6-81.7 296.2 0 81.8 81.7 81.8 214.5.1 296.2z"
          />
          <circle cx="236.381" cy="236.5" r="16.6" />
          <circle cx="321.981" cy="236.5" r="16.6" />
          <circle cx="150.781" cy="236.5" r="16.6" />
        </svg>
      </span>
    );
  } else if (via === "Formulario") {
    return (
      <span>
        <svg
          className="h-4"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 512.001 512.001"
        >
          <path
            stroke="#3c6ebe"
            d="M463.996 126.864L340.192 3.061A10.452 10.452 0 00332.803 0H95.726C67.724 0 44.944 22.782 44.944 50.784v410.434c0 28.001 22.781 50.783 50.783 50.783h320.547c28.002 0 50.783-22.781 50.783-50.783V134.253a10.458 10.458 0 00-3.061-7.389zM343.255 35.679l88.127 88.126H373.14c-7.984 0-15.49-3.109-21.134-8.753-5.645-5.643-8.752-13.148-8.751-21.131V35.679zm102.903 425.538c0 16.479-13.406 29.885-29.884 29.885H95.726c-16.479 0-29.885-13.406-29.885-29.885V50.784c.001-16.479 13.407-29.886 29.885-29.886h226.631v73.021c-.002 13.565 5.28 26.318 14.871 35.909 9.592 9.592 22.345 14.874 35.911 14.874h73.018v316.515z"
          />
          <path
            stroke="#3c6ebe"
            d="M147.789 303.745h-4.678c-5.77 0-10.449 4.678-10.449 10.449s4.679 10.449 10.449 10.449h4.678c5.77 0 10.449-4.678 10.449-10.449s-4.679-10.449-10.449-10.449zM368.889 303.745H181.593c-5.77 0-10.449 4.678-10.449 10.449s4.679 10.449 10.449 10.449h187.296c5.77 0 10.449-4.678 10.449-10.449s-4.679-10.449-10.449-10.449zM147.789 256h-4.678c-5.77 0-10.449 4.678-10.449 10.449s4.679 10.449 10.449 10.449h4.678c5.77 0 10.449-4.678 10.449-10.449S153.559 256 147.789 256zM368.889 256H181.593c-5.77 0-10.449 4.678-10.449 10.449s4.679 10.449 10.449 10.449h187.296c5.77 0 10.449-4.678 10.449-10.449S374.659 256 368.889 256zM147.789 208.255h-4.678c-5.77 0-10.449 4.678-10.449 10.449s4.679 10.449 10.449 10.449h4.678c5.77 0 10.449-4.678 10.449-10.449s-4.679-10.449-10.449-10.449zM368.889 208.255H181.593c-5.77 0-10.449 4.678-10.449 10.449s4.679 10.449 10.449 10.449h187.296c5.77 0 10.449-4.678 10.449-10.449s-4.679-10.449-10.449-10.449z"
          />
        </svg>
      </span>
    );
  } else if (via === "helppeople") {
    return (
      <svg
        width="16"
        height="11"
        viewBox="0 0 21 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M15.8438 7.13309C15.5139 3.75185 13.209 1.69531 10.5 1.69531C7.93945 1.69531 6.29031 3.51546 5.75 5.3205C3.52344 5.54707 1.59375 6.96656 1.59375 9.54989C1.59375 12.0422 3.59766 13.7793 6.04688 13.7793H15.6953C17.7363 13.7793 19.4063 12.7431 19.4063 10.4562C19.4063 8.19724 17.4395 7.21768 15.8438 7.13309Z"
          stroke="#3948FF"
          strokeWidth="1.5"
          strokeLinejoin="round"
        />
      </svg>
    );
  } else if (via === "helppeopleMobile") {
    return (
      <span>
        <svg
          className="h-4"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 427.913 427.913"
        >
          <path
            stroke="#3c6ebe"
            d="M406.406 203.592c-12.394-15.255-29.272-26.407-48.006-31.829-2.156-57.889-49.923-104.319-108.329-104.319-24.725 0-48.912 8.545-68.103 24.061-16.482 13.326-28.748 31.302-35.166 51.316a73.505 73.505 0 00-27.256-5.253c-40.308 0-73.134 32.649-73.418 72.892C18.327 223.07 0 251.153 0 281.979c0 43.28 35.211 78.491 78.491 78.491h253.183c53.067 0 96.24-43.173 96.239-96.239 0-22.034-7.638-43.569-21.507-60.639zM331.674 345.47H78.491C43.482 345.47 15 316.988 15 281.979c0-26.419 16.638-50.345 41.4-59.538a7.5 7.5 0 004.874-7.528 58.719 58.719 0 01-.148-3.926c0-32.213 26.207-58.42 58.42-58.42a58.387 58.387 0 0128.46 7.414 7.5 7.5 0 0010.977-4.885c4.607-20.309 16.119-38.749 32.416-51.925 16.531-13.366 37.368-20.726 58.672-20.726 51.504 0 93.405 41.901 93.405 93.405 0 .444-.009.886-.016 1.328l-.005.296a7.5 7.5 0 005.876 7.448c17.756 3.934 33.891 13.924 45.433 28.129 11.704 14.404 18.149 32.581 18.149 51.18 0 44.795-36.444 81.239-81.239 81.239z"
          />
        </svg>
      </span>
    );
  } else if (via === "Mail") {
    return (
      <svg
        width="16"
        height="11"
        viewBox="0 0 17 13"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0)">
          <path
            d="M14.8391 0.640625H2.16158C1.32805 0.640625 0.652344 1.29646 0.652344 2.10547V10.8945C0.652344 11.7035 1.32805 12.3594 2.16158 12.3594H14.8391C15.6727 12.3594 16.3484 11.7035 16.3484 10.8945V2.10547C16.3484 1.29646 15.6727 0.640625 14.8391 0.640625Z"
            stroke="#3948FF"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M3.06641 2.98438L8.49964 7.08593L13.9329 2.98438"
            stroke="#3948FF"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0">
            <rect width="17" height="13" fill="white" />
          </clipPath>
        </defs>
      </svg>
    );
  } else if (via === "Personal") {
    return (
      <span>
        <svg
          className="h-4"
          viewBox="-42 0 512 512.002"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            stroke="#3c6ebe"
            d="M210.352 246.633c33.882 0 63.222-12.153 87.195-36.13 23.973-23.972 36.125-53.304 36.125-87.19 0-33.876-12.152-63.211-36.129-87.192C273.566 12.152 244.23 0 210.352 0c-33.887 0-63.22 12.152-87.192 36.125s-36.129 53.309-36.129 87.188c0 33.886 12.156 63.222 36.133 87.195 23.977 23.969 53.313 36.125 87.188 36.125zm0 0M426.129 393.703c-.692-9.976-2.09-20.86-4.149-32.351-2.078-11.579-4.753-22.524-7.957-32.528-3.308-10.34-7.808-20.55-13.37-30.336-5.774-10.156-12.555-19-20.165-26.277-7.957-7.613-17.699-13.734-28.965-18.2-11.226-4.44-23.668-6.69-36.976-6.69-5.227 0-10.281 2.144-20.043 8.5a2711.03 2711.03 0 01-20.879 13.46c-6.707 4.274-15.793 8.278-27.016 11.903-10.949 3.543-22.066 5.34-33.039 5.34-10.972 0-22.086-1.797-33.047-5.34-11.21-3.622-20.296-7.625-26.996-11.899-7.77-4.965-14.8-9.496-20.898-13.469-9.75-6.355-14.809-8.5-20.035-8.5-13.313 0-25.75 2.254-36.973 6.7-11.258 4.457-21.004 10.578-28.969 18.199-7.605 7.281-14.39 16.12-20.156 26.273-5.558 9.785-10.058 19.992-13.371 30.34-3.2 10.004-5.875 20.945-7.953 32.524-2.059 11.476-3.457 22.363-4.149 32.363A438.821 438.821 0 000 423.949c0 26.727 8.496 48.363 25.25 64.32 16.547 15.747 38.441 23.735 65.066 23.735h246.532c26.625 0 48.511-7.984 65.062-23.734 16.758-15.946 25.254-37.586 25.254-64.325-.004-10.316-.351-20.492-1.035-30.242zm0 0"
          />
        </svg>
      </span>
    );
  } else if (via === "Telefono") {
    return (
      <svg
        width="16"
        height="11"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0)">
          <path
            d="M16.7896 13.7147C16.1552 13.0755 14.6187 12.1427 13.8733 11.7668C12.9025 11.2778 12.8226 11.2378 12.0595 11.8047C11.5506 12.183 11.2122 12.521 10.6165 12.394C10.0209 12.2669 8.72648 11.5506 7.59309 10.4208C6.4597 9.29104 5.70184 7.95909 5.5744 7.36543C5.44696 6.77177 5.79053 6.43739 6.16527 5.92722C6.69341 5.20812 6.65346 5.08827 6.20202 4.11747C5.85006 3.36241 4.89005 1.84031 4.24845 1.20909C3.56211 0.531138 3.56211 0.650989 3.11986 0.83476C2.75981 0.986247 2.4144 1.17039 2.08794 1.38488C1.44874 1.80955 1.09398 2.16231 0.845887 2.69245C0.597796 3.22259 0.486335 4.46544 1.76754 6.79294C3.04875 9.12045 3.94763 10.3106 5.80811 12.1659C7.6686 14.0212 9.09922 15.0187 11.1906 16.1916C13.7778 17.6406 14.7702 17.3582 15.3019 17.1105C15.8336 16.8628 16.188 16.5113 16.6135 15.872C16.8285 15.5461 17.0131 15.2011 17.1648 14.8413C17.349 14.4007 17.4688 14.4007 16.7896 13.7147Z"
            stroke="#3948FF"
            strokeWidth="1.5"
            strokeMiterlimit="10"
          />
        </g>
        <defs>
          <clipPath id="clip0">
            <rect width="18" height="18" fill="white" />
          </clipPath>
        </defs>
      </svg>
    );
  }
  return (
    <span>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="h-4 w-4"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
        />
      </svg>
    </span>
  );
};
